import { extend } from 'vee-validate';

type CardEntry = {
  value?: string;
};

type CardValidationArgs = {
  cards: CardEntry[];
  cardValue?: string;
};

function normalizeCardValue(value?: string): string {
  return (value || '').trim().toUpperCase();
}

extend('equalsCards', {
  params: ['cards', 'cardValue'],
  validate: (value: string, args: CardValidationArgs) => {
    const normalizedCardValue = normalizeCardValue(args.cardValue || value);
    if (!normalizedCardValue) {
      return true;
    }
    const sameCards = args.cards.filter(
      ({ value: cardEntryValue }) => normalizeCardValue(cardEntryValue) === normalizedCardValue,
    );
    return sameCards.length === 1;
  },
  message: 'nightRider.validations.sameCards',
});

extend('noDuplicateAmongCards', {
  params: ['cards', 'cardValue'],
  validate: (value: string, args: CardValidationArgs) => {
    const normalizedCardValue = normalizeCardValue(args.cardValue || value);
    if (!normalizedCardValue) {
      return true;
    }
    return !args.cards.some(
      ({ value: cardEntryValue }) => normalizeCardValue(cardEntryValue) === normalizedCardValue,
    );
  },
  message: 'nightRider.validations.sameCards',
});
